import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '../../contexts/CurrentUserContext';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

/**
 * 路由守卫组件
 * 优先读 CurrentUserContext（内存），与 localStorage 持久化配合，避免登录后立即跳转时误判未登录
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isUserLoggedIn } = useCurrentUser();
  const isLoggedIn = isUserLoggedIn();

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
